"use client";
import { fanduel as fd } from "@fanduel/formation-tokens";
import { BasicTeam, EventStatus } from "@/graphql/gql/graphql";
import { useHeadToHeadContext } from "@/utils/hooks/useHeadToHeadContext";
import LivePostMatchupMain from "./LivePostMatchupMain";
import PreMatchupMain from "./PreMatchupMain";

export type MatchupBasicTeam = Omit<
  BasicTeam,
  "name" | "primaryColor" | "secondaryColor" | "logoSVG"
> & {
  name: string;
  primaryColor: string;
  secondaryColor: string;
  logoSVG: string;
};

const MatchupMainWrapper = () => {
  const { gameState, homeTeam, awayTeam } = useHeadToHeadContext();
  const definedHomeTeam: MatchupBasicTeam = {
    ...homeTeam,
    name: homeTeam?.name ?? "Home",
    primaryColor: homeTeam?.primaryColor ?? fd.colors.brandPrimaryDefault,
    secondaryColor: homeTeam?.secondaryColor ?? fd.colors.brandSecondaryShade,
    logoSVG: homeTeam?.logoSVG ?? "",
  };

  const definedAwayTeam: MatchupBasicTeam = {
    ...awayTeam,
    name: awayTeam?.name ?? "Away",
    primaryColor: awayTeam?.primaryColor ?? fd.colors.brandPrimaryDefault,
    secondaryColor: awayTeam?.secondaryColor ?? fd.colors.brandSecondaryShade,
    logoSVG: awayTeam?.logoSVG ?? "",
  };

  if (gameState === EventStatus.Final || gameState === EventStatus.Live) {
    return (
      <LivePostMatchupMain
        homeTeam={definedHomeTeam}
        awayTeam={definedAwayTeam}
      />
    );
  }

  return (
    <PreMatchupMain homeTeam={definedHomeTeam} awayTeam={definedAwayTeam} />
  );
};

export default MatchupMainWrapper;
